export default "__VITE_ASSET__fKbdVW7d__"